// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'currentDealer',
                    value: 'Current Dealer'
                },
                {
                    key: 'currentDealerName',
                    value: 'Current Dealer Name'
                },
                {
                    key: 'newDealer',
                    value: 'New Dealer'
                },
                {
                    key: 'newDealerName',
                    value: 'New Dealer Name'
                },
                {
                    key: 'requestDate',
                    value: 'Request Date'
                },
                {
                    key: 'requestedBy',
                    value: 'Requested By'
                },
                {
                    key: 'changedOn',
                    value: 'Changed On'
                },
                {
                    key: 'changedBy',
                    value: 'Changed By'
                },
                {
                    key: 'statusIndicator',
                    value: 'Status Indicator'
                },
                {
                    key: 'customer',
                    value: 'Customer'
                },
                {
                    key: 'reasonForChange',
                    value: 'Reason For Change'
                },
                {
                    key: 'deereRemarks',
                    value: 'Deere Remarks'
                },
                {
                    key: 'approvalDealerComments',
                    value: 'Approval Dealer Comments'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'requestDate',
                    order: 'DESC',
                    value: 'Request Date'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/state/views.js